import React from 'react';

interface Props {
  id: string;
}
export const OwnerImplement = ({ id, }:Props) => {
  return (
    <div>
      realizacje { id }
    </div>
  );
};
